import React, { useEffect, useState } from 'react';
import { t } from '../i18n.js';

interface Props {
  className?: string;
}

const ScrollToTopButton: React.FC<Props> = ({ className = '' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const anchor = document.getElementById('document-top');

    let container: HTMLElement | Window = window;
    let el: HTMLElement | null = anchor ? anchor.parentElement : null;
    while (el && el !== document.body) {
      const style = window.getComputedStyle(el);
      if (['auto', 'scroll'].includes(style.overflowY) && el.scrollHeight > el.clientHeight) {
        container = el;
        break;
      }
      el = el.parentElement;
    }

    const onScroll = () => {
      const pos = container === window ? window.scrollY : (container as HTMLElement).scrollTop;
      setVisible(pos > 300);
    };

    container.addEventListener('scroll', onScroll);
    return () => container.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    const anchor = document.getElementById('document-top');

    let container: HTMLElement | Window = window;
    let el: HTMLElement | null = anchor ? anchor.parentElement : null;
    while (el && el !== document.body) {
      const style = window.getComputedStyle(el);
      if (['auto', 'scroll'].includes(style.overflowY) && el.scrollHeight > el.clientHeight) {
        container = el;
        break;
      }
      el = el.parentElement;
    }

    if (container === window) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      window.scrollTo(0, 0);
    } else {
      (container as HTMLElement).scrollTo({ top: 0, behavior: 'smooth' });
      (container as HTMLElement).scrollTop = 0;
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      title={t('scroll_top', 'Scroll to top')}
      className={`bg-white dark:bg-gray-900 text-black dark:text-white p-2 rounded-full shadow-lg hover:scale-110 transition-transform ${className}`}
    >
      ⬆️
    </button>
  );
};

export default ScrollToTopButton;
